// init.js
import req from './axios';
import { isMockJs } from './axios'


export const queryApiDoc = () => req('get', isMockJs ? '/apiDoc' : '/');

